import type {
  DataMutate,
  OptionType,
  SupportedLanguage,
  WithPagination,
} from "../../../../../types/types";
import type { Assets, PIMProduct } from "../../../../../types/types.PIM";
import { AssetContainerType } from "../../../../../util/assetContainer.types";
import { NewAssetFormV2 } from "../NewAssetFormV2";
import type { NewAssetFormSubmitValues } from "../util";

export const AddAssetsForm = ({
  title,
  product,
  assetContainerType,
  onComplete,
  fetchProductData,
  uploadNewDocumentsOnly = false,
  hideAccessibility = false,
  onCancel,
  onAddExistingAssets,
  onAddNewAssetData,
}: {
  title: string;
  onComplete: (productId?: string) => void;
  product: PIMProduct;
  assetContainerType: AssetContainerType;
  fetchProductData: DataMutate<WithPagination<{ data: Assets[] }>>;
  uploadNewDocumentsOnly?: boolean;
  hideAccessibility?: boolean;
  allowUpload?: boolean;
  onCancel?: () => void;
  onAddExistingAssets?: ({
    selected_assets,
    selected_product,
    selected_language,
  }: {
    selected_assets: Assets[];
    selected_product?: OptionType<string>;
    selected_language?: OptionType<SupportedLanguage>;
  }) => Promise<void>;
  onAddNewAssetData?: (data: NewAssetFormSubmitValues) => Promise<void>;
}) => (
  <NewAssetFormV2
    title={title}
    defaultAssetType={title ?? "Documents"}
    product={product}
    onComplete={onComplete}
    refreshParentData={fetchProductData}
    uploadNewDocumentsOnly={uploadNewDocumentsOnly}
    hideAccessibility={hideAccessibility}
    onCancel={onCancel ?? onComplete}
    onAddExistingAssets={onAddExistingAssets}
    onAddAssetData={onAddNewAssetData}
    assetContainerType={assetContainerType}
  />
);
